"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import React from "react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      style={
        {
          "--normal-bg": "var(hsl(--popover))",
          "--normal-text": "var(hsl(--popover-foreground))",
          "--normal-border": "var(hsl(--border))",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
